// GET QME Option Api
export const getQualifiedAPi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/qualified-maintenance-events${queryString ? `?${queryString}` : ""}`;
};
// POST QME Api
export const addQMEApi = (params) => {
    return `lease/${params?.leaseSlug}/qualified-maintenance-events`;
};
// PUT QME Api
export const updateQMEApi = (params) => {
    return `lease/${params?.leaseSlug}/qualified-maintenance-events/${params?.slug}`;
};
// DELETE QME Api
export const deleteQmeApi = (params) => {
    return `lease/${params?.leaseSlug}/qualified-maintenance-events`;
};
// Post File QME Api
export const qmefileUploadApi = (slug) => {
    return `lease/qualified-maintenance-events/${slug}/attachments`;
};

// Reserve account  api
export const reserveAccountApi = (params) => {
    return `/lease/${params?.leaseSlug}/reserve_accounts/?lite=true`;
};

export const qualifiedfileUploadPostApi = (qualified_slug) => {
    return `/get-pre-signed-url/qualified_maintenance_event/${qualified_slug}`;
};

export const qualifiedAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/qualified_maintenance_event/${attachments_slug}`
}
